import React from "react";

const SubHeading = (props) => {
  return (
    <>
      {/* Heading */}
      <div
        className={`border-b-2 border-${props.color} flex flex-row justify-between items-center`}
      >
        <div
          className={`bg-${props.color} inline-block uppercase text-sm py-1.5 px-2 text-white`}
        >
          {props.text}
        </div>
        <div className="flex flex-row">
          {/* <div className="text-gray-400 text-xs mr-6">All</div>
          <div className="text-gray-400 text-xs mr-6">Style Hunter</div>
          <div className="text-gray-400 text-xs mr-6">Vouge</div>
          <div className="text-gray-400 text-xs mr-6">Health & Fitness</div>
          <div className="text-gray-400 text-xs mr-6">Travel</div>
          <div className="text-gray-400 text-xs mr-6">Gadgets</div>
          <div className="text-gray-400 text-xs mr-6">More</div> */}
        </div>
      </div>
    </>
  );
};


export default SubHeading;
